module.exports = __webpack_public_path__ + "img/hr.68be2894.svg";